/**
 * Projects MVI Reducer
 *
 * Pure function: (state, intent) => newState.
 * No I/O, no side effects.
 */

import type { IProjectsState } from "./state";
import type { TProjectsIntent } from "./intents";

export function projectsReducer(
  state: IProjectsState,
  intent: TProjectsIntent,
): IProjectsState {
  switch (intent.type) {
    case "LOAD_PROJECTS_START":
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case "LOAD_PROJECTS_SUCCESS":
      return {
        ...state,
        projects: intent.projects,
        isLoading: false,
        error: null,
        // Приход перечня выбор проекта не делает. Проект — контекст, названный
        // адресом (app-shell-shell-routing-R12): выбирает его разбор адреса —
        // проект из ссылки, а когда адрес проекта не называет, проект по
        // умолчанию (administration-projects-R07), и тот сразу отражается в
        // адресе. Выбор здесь опережал бы адрес и на мгновение показывал
        // содержимое не того проекта, который назван в ссылке.
        selectedProjectId: intent.projects.some(
          (project) => project.id === state.selectedProjectId,
        )
          ? state.selectedProjectId
          : "",
      };

    case "LOAD_PROJECTS_ERROR":
      return {
        ...state,
        isLoading: false,
        error: intent.error,
      };

    case "SELECT_PROJECT":
      return {
        ...state,
        selectedProjectId: intent.projectId,
      };

    case "CREATE_PROJECT_START":
      return {
        ...state,
        isCreating: true,
        error: null,
      };

    case "CREATE_PROJECT_SUCCESS":
      return {
        ...state,
        projects: [...state.projects, intent.project],
        selectedProjectId: intent.project.id,
        isCreating: false,
      };

    case "CREATE_PROJECT_ERROR":
      return {
        ...state,
        isCreating: false,
        error: intent.error,
      };

    default:
      return state;
  }
}
